import { render } from "./recent-file.vue?vue&type=template&id=e34acac2"
import script from "./recent-file.vue?vue&type=script&lang=js"
export * from "./recent-file.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__